/* src/app/shared/components/form-controls/ag-select/ag-select.component.scss */
select {
  border: none;
  outline: 0;
  height: 100%;
  width: 100%;
  flex: none;
  padding-top: 11px;
  margin-left: -2px;
  background-color: #ffffff;
}
select:not(:disabled) {
  cursor: pointer;
}
select:disabled {
  color: #333333;
  opacity: 1;
}
select:focus ~ label.has-value {
  color: #61566e;
  font-weight: bolder;
}
label.has-value {
  font-size: 10px;
  top: 0px;
  opacity: 1;
  transition: 0.2s ease all;
  color: #333333;
}
/*# sourceMappingURL=ag-select.component.css.map */
